import {useContext} from "react";
import UIService from "../../../services/UIService";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";
import UserContext from "../../../contexts/UserContext";
import {ProfilePassword} from "../ProfilePassword/ProfilePassword";
import {ProfilePreferences} from "../ProfilePreferences/ProfilePreferences";

export const ProfileFn = () => {
    const userModel = useContext(UserContext);

    let cardClass = "card";

    if (!UIService.isMainViewLight()) {
        cardClass += " bg-dark text-white";
    }

    return <div className={"ProfileFn"}>
        <div className={"row"}>
            <OwTitle className={"mt-3 col-12 col-md-2"} leftIconName={"fad fa-user-circle"} title={"user_profile"} />
        </div>

        <div className="row mt-4 mb-4">
            <div className="col-12">
                <div className={cardClass}>
                    <div className="card-body">
                        <OwLabel title={"email"} postText={":"} className={"me-2"} isBold={true}/>
                        {userModel.email}
                    </div>
                </div>

            </div>
        </div>

        <div className={"row"}>
            <div className={"col-12 col-md-6 mt-2 "}>
                <ProfilePassword/>
            </div>
            <div className={"col-12 col-md-6 mt-2 "}>
                <ProfilePreferences/>
            </div>
        </div>
    </div>;
};
